import styled from 'styled-components/macro';
import { COLORS, TYPOGRAPHY } from 'styleguide';

const Tab = styled.button`
  padding: 5px 16px;
  border: none;
  background-color: ${({ active }) => (active ? COLORS.primary : COLORS.line)};
  color: ${({ active }) => (active ? '#fff' : COLORS.gray60)};
  text-align: center;
  ${TYPOGRAPHY.button}
  cursor: pointer;
  transition: background-color 0.15s ease-out, color 0.15s ease-out;

  &:hover {
    color: #fff;
  }

  &:disabled {
    color: ${COLORS.gray40};
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

export default Tab;
